import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import * as XLSX from "xlsx";

// Custom component to display each stat item
const StatItem = ({ label, value, color }) => {
  return (
   <Grid item xs={12} sm={6} md={4}>
      <Box
        sx={{
          p: 2,
          borderRadius: 2,
          backgroundColor: '#f9f9f9',
          boxShadow: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color }}>
          {label}
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {value}
        </Typography>
      </Box>
    </Grid>
  );
};

export default function VisitorStatsModal({
  filtered_visitors,
  open,
  setOpen,
}) {
  // Derived values
  const totalVisitors = filtered_visitors?.length || 0;
  const maleVisitors = filtered_visitors.filter(
    (visitor) => visitor.gender === "male"
  ).length;
  const femaleVisitors = filtered_visitors.filter(
    (visitor) => visitor.gender === "female"
  ).length;

  // Download as Excel (.xlsx)
  const handleDownload = () => {
    const stats = [
      ["Total Visitors", totalVisitors],
      ["Male Visitors", maleVisitors],
      ["Female Visitors", femaleVisitors],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([
      ["Visitor Statistics", ""],
      ...stats,
    ]);
    worksheet["!cols"] = [{ width: 30 }, { width: 20 }];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Visitor Stats");
    XLSX.writeFile(workbook, "visitor_stats.xlsx");
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
        },
      }}
    >
      <DialogTitle className="w-full text-center">
        Visitor Statistics
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <StatItem
            label="Total Visitors"
            value={totalVisitors}
            color="#D71920"
          />
          <StatItem
            label="Male Visitors"
            value={maleVisitors}
            color="#F7931E"
          />
          <StatItem
            label="Female Visitors"
            value={femaleVisitors}
            color="#0288D1"
          />
        </Grid>

        <Box mt={3} display="flex" justifyContent="center">
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={handleDownload}
          >
            Download Stats
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
